export function toPhoneNumber(phoneNumber = "") {
    if (!phoneNumber) {
        return "";
    }
    return phoneNumber.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, (_, p1, p2, p3) => {
        const parts = [];
        if (p1)
            parts.push(`(${p1}`);
        if (p2)
            parts.push(`) ${p2}`);
        if (p3)
            parts.push(`-${p3}`);
        return parts.join("");
    });
}
